import { MouseEventHandler, ReactNode } from 'react'
import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'

interface INamedNumber {
  className?: string
  name: string
  number: number | ReactNode
  onClick?: MouseEventHandler
  opaque?: boolean
}

const NamedNumber = ({ className, name, number, onClick, opaque }: INamedNumber) => (
  <Container
    className={className}
    onClick={onClick}
    opaque={opaque}
  >
    <Number>{number}</Number>
    <Name>{name}</Name>
  </Container>
)

const Container = styled.div<{ opaque?: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  font-size: 12px;
  gap: 6px;
  align-items: flex-start;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    flex-flow: column nowrap;
    align-items: unset;
  }
  opacity: ${({ opaque }) => opaque && '15%'};
`

const Number = styled.span`
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
`

const Name = styled.span`
  font-weight: 700;
  line-height: 14.5px;
  max-width: 80px;
  line-height: 12px;
`

export default NamedNumber
